export const colors = {
    gray: '#8C8F90',
    dark: '#041B15',
    dark2:'#041B15A3',
    yellow:'#FFCF06',
    green:'#37C08E',
    blue:'#60CAE4',
    green2:'#1C4234',
    white:'#FFFFFF'
}